import * as React from "react";
import "./FeatureTypeSelector.scss";
import {TweenMax} from "gsap/TweenMax";
import {Linear} from "gsap/EasePack";
import {IFeature, IFeatureType} from "../OverviewScreen";
import {FeatureTypeSelectorPanel} from "./featureTypeSelectorPanel/FeatureTypeSelectorPanel";

export interface FeatureTypeSelectorProps {
    keyString: string;
    active: boolean;
    contentPath: string,
    feature: IFeature
    linksBaseURL: string;
    featureTypes: IFeatureType[];
    notifyLinkPress: (feature: IFeature) => void;
    notifyClosePress: (feature: IFeature) => void;
}

export class FeatureTypeSelector extends React.Component<FeatureTypeSelectorProps, {}> {

    state = {
        alpha: 0,
        screenLocked: true,
        selectedLink: null,
    };

    stateAnimationProxy: any = {
        alpha: 0,
        scale: .5,
    };

    stateAnimationProxySynchronize = () => {
        this.setState(
            this.stateAnimationProxy
        );
    };

    componentWillReceiveProps(nextProps: FeatureTypeSelectorProps): void {
        if (nextProps.active != this.props.active) {
            const DUR: number = (nextProps.active) ? .3 : .15;

            TweenMax.to(this.stateAnimationProxy, DUR,
                {
                    alpha: nextProps.active ? 1 : 0,
                    scale: nextProps.active ? 1 : .5,
                    ease: Linear.easeInOut,
                    onComplete: this.stateAnimationProxySynchronize,
                    onUpdate: this.stateAnimationProxySynchronize
                }
            );
        }
    }

    openLink = (link: string): void => {
        window.open(this.props.linksBaseURL + this.props.linksBaseURL + link, "_self");
    };

    // ++++++++++++++++++++++++++++++
    // Mouse handling
    // ++++++++++++++++++++++++++++++

    mouseEventHandler = (e: any, link: string): void => {
        (e as Event).preventDefault();

        switch ((e as Event).type) {
            case "mouseover":
                this.setState({
                    selectedLink: link
                });
                break;
            case "mouseout":
                this.setState({
                    selectedLink: null
                });
                break;
            case "click":
                this.openLink(link);
                break;
            default:
                console.log("unknown mouse event:", (e as Event).type);
        }
    };

    onCloseMouseHandler = (e: any) => {
        e.preventDefault();

        switch ((e as Event).type) {
            case "click":
                this.props.notifyClosePress(this.props.feature);
                break;
        }
    };

    createPanel = (item: IFeatureType, index: number): JSX.Element => {
        const isSelected: boolean = (this.state.selectedLink == item.$.href);

        return <FeatureTypeSelectorPanel
            key={'panel-' + index}
            keyString={'panel-' + index}
            data={item}
            selected={isSelected}
            fadeInDelay={index * .2}
            contentPath={this.props.contentPath}
            notifyLinkPress={this.mouseEventHandler}
            onOver={this.mouseEventHandler}
            onOut={this.mouseEventHandler}/>;
    };

    render() {
        const typePanels: JSX.Element[] = (this.props.featureTypes) ? this.props.featureTypes.map(this.createPanel) : [];

        TweenMax.set('.FeatureTypeSelector.' + this.props.keyString, {
            autoAlpha: this.state.alpha
        });

        if (this.state.alpha == 0) {
            return null;
        }

        return <div className={'FeatureTypeSelector ' + this.props.keyString} onClick={this.onCloseMouseHandler}>
            <div className={'inner'}>
                <div className={'center'}>
                    <div className={'closeQuad'} onClick={this.onCloseMouseHandler}>
                        <svg width="50%" height="50%" viewBox="0 0 22.1 22.1">
                            <line strokeWidth={3} stroke={'#FFFFFF'} x1="1.1" y1="1.1" x2="21.1" y2="21.1"/>
                            <line strokeWidth={3} stroke={'#FFFFFF'} x1="1.1" y1="21.1" x2="21.1" y2="1.1"/>
                        </svg>
                    </div>

                    {typePanels}
                </div>
            </div>
        </div>;
    }
}
